// Lucide icon: wallet (https://lucide.dev/icons/wallet)
import { Wallet } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconExpense = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Wallet />
    </IconComponentStyled>
  )
}
